import React, { useState, useContext } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { toast } from "react-toastify";
import { showSuccess, showError } from "../../../utils/toast";
import { FaTrashRestore } from "react-icons/fa";
import restoreUser from "../../../api/restoreUser";
import { AuthContext } from "../../../context/Auth/AuthContext";
import ButtonUI from "../../material-ui/ButtonUI";
import restore from "../../../images/recover-recycle-bin.svg";

const RestoreUser = ({ id, setUserRestoredToTrue }) => {
  const [open, setOpen] = useState(false);
  const { token } = useContext(AuthContext);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onRestoreUser = async () => {
    const restoreUserFormResponse = await restoreUser({
      token: token,
      id: id,
    });

    if (restoreUserFormResponse.code === 200) {
      setOpen(false);
      setUserRestoredToTrue();
      showSuccess("User is restored successfully");
    }
  };

  return (
    <div className="dialog-modal">
      <ButtonUI
        formButton={false}
        variant="outlined"
        buttonText={<FaTrashRestore />}
        style={{
          color: "#28a745",
          marginRight: "5px",
          padding: "6px",
          minWidth: "fit-content",
          border: "none",
          boxShadow: "none",
          fontSize: "18px",
        }}
        sx={{
          backgroundColor: "transparent",
          "&:hover": { backgroundColor: "rgba(40, 167, 69, 0.12)" },
        }}
        onClickFunc={handleClickOpen}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className="edit-doc-modal">
          <div className="popup-header-svg-icon">
            <FaTrashRestore />
          </div>
          <div className="popup-header-title">Restore User</div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to restore this User ?
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: "flex-end" }}>
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="No"
            style={{
              margin: "15px 0px",
              backgroundColor: "#fff",
              color: "#1a6b7c",
              border: "1px solid #1a6b7c",
            }}
            onClickFunc={handleClose}
          />
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="Yes"
            style={{
              margin: "15px",
              backgroundColor: "#fff",
              color: "#1a6b7c",
              border: "1px solid #1a6b7c",
            }}
            autoFocus={true}
            onClickFunc={onRestoreUser}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default RestoreUser;
